// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .button-plan:active {
   border: 5px solid cornflowerblue;
} */

* {
  box-sizing: border-box;
  /* justify-content: center;
   align-items: center; */
}

div.column:nth-child(1) > ul:nth-child(1) > li:nth-child(1) {
  padding-top: 89px;
}

.table {
  margin-left: auto;
  margin-right: auto;
  margin-top: 48px;
}

.column {
  float: left;
  column-width: auto;
}

/* Clear floats after the columns */
.row:after {
  content: '';
  display: table;
  clear: both;
}

/* Style the list */
.price {
  list-style-type: none;
  /* border: 1px solid var(--color-bg-mid-grey); */
  margin: 0;
  padding: 0;
  transition: 0.3s;
  margin-right: 61px;
}

.price li {
  padding: 16px;
}

/* Add shadows on hover */
.price:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}

/* Pricing header */
/* .price .header {
   color: rgb(0, 0, 0);
   font-size: 20px;
 } */

/* List items */
.price li {
  /* border-bottom: 1px solid var(--color-bg-mid-grey); */
  padding: 20px;
  text-align: left;
}

/* Grey list item */
.price .grey {
  background-color: var(--color-bg-mid-grey);
  font-size: 20px;
}

/* The "Sign Up" button */
.button {
  background-color: var(--color-success-material);
  border: none;
  color: white;
  padding: 10px 25px;
  text-align: center;
  text-decoration: none;
  font-size: 18px;
}

.featureList {
  text-align: left;
}

.amount {
  font-family: 'Inter';
  font-size: 48px;
  font-weight: 999;
  line-height: 43px;
  letter-spacing: -0.02em;
  text-align: center;
  color: var(--color-primary);
}

.amountDuration {
  font-family: Raleway;
  font-size: 16px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0em;
  text-align: center;
  color: rgba(29, 41, 57, 1);
}

/* Change the width of the three columns to 100%
   (to stack horizontally on small screens) */
@media only screen and (max-width: 600px) {
  .columns {
    width: 100%;
  }
}

/* p {
  font-family: Arial;
  font-size: 9px;
} */

/* .column {
   float: left;
   width: 33.33%;
 } */

/* Clear floats after the columns */
.row:after {
  content: '';
  display: table;
  clear: both;
}

.dollar:before {
  content: '\$';
  vertical-align: top;
  font-family: Raleway;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--color-primary);
  margin-right: 8px;
}

.dollarWhite:before {
  content: '\$';
  vertical-align: top;
  font-family: Raleway;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  color: white;
  margin-right: 8px;
}

.timeline {
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: var(--color-primary);
}

.change-plan-wrapper .btn {
  background: var(--color-accent-violet);
  color: var(--color-white) !important;
  font-weight: 100;
  padding: 20px;
  /* text-transform: uppercase; */
  border-radius: 6px;
  display: inline-block;
  transition: all 0.3s ease 0s;
}

.change-plan-wrapper .btn:hover {
  color: var(--color-text-charcoal) !important;
  font-weight: 700 !important;
  letter-spacing: 3px;
  background: none;
  -webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  -moz-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);
  transition: all 0.3s ease 0s;
}

/* Animation code */
.slide-left {
  animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

/**
 * ----------------------------------------
 * animation slide-left
 * ----------------------------------------
 */

@keyframes slide-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(116px);
  }
}

.slide-right {
  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

/**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */

@keyframes slide-right {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-120px);
  }
}

/* Add this class to smoothly transition background color and text color */
.slide-right-new {
  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

/**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */

@keyframes slide-right-new {
  0% {
    background-color: 'transparent';
    background-color: 'initial';
    /* Set the initial background color */
    color: '#000';
    color: 'initial';
    /* Set the initial text color */
    transform: translateX(0);
  }

  100% {
    background-color: 'blue';
    /* Set the target background color */
    color: 'white';
    /* Set the target text color */
    transform: translateX(100px);
  }
}

/**
 * ----------------------------------------
 * animation slide-right
 * ----------------------------------------
 */
/* Add this class to smoothly transition background color and text color */
.slide-left-new {
  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-left-new {
  0% {
    background-color: 'transparent';
    background-color: 'initial';
    /* Set the initial background color */
    color: '#000';
    color: 'initial';
    /* Set the initial text color */
    transform: translateX(0);
  }

  100% {
    background-color: 'blue';
    /* Set the target background color */
    color: 'white';
    /* Set the target text color */
    transform: translateX(-100px);
  }
}

/* Corrected keyframes for .slide-l */
@keyframes slide-l {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}

/* Corrected keyframes for .slide-r */
@keyframes slide-r {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0);
  }
}

/* Apply initial styles and transition to the element with cubic-bezier timing function */
.slide-l {
  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-r {
  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.custom-tab-list div[role='tablist'] {
  display: block !important;
}

.row-wrapper {
  padding-top: 1.5rem;
}

.table-row {
  display: table-row;
}

.table-row > td {
  padding-top: 1rem;
}

@keyframes shakeJerk {
  0% {
    transform: translateX(-50%);
  }
  12.5% {
    transform: translateX(calc(-50% - 6px));
  }
  25% {
    transform: translateX(calc(-50% + 6px));
  }
  37.5%, 100% {
    transform: translateX(-50%);
  }
}

.shake-jerk-handle {
  animation: shakeJerk 1.5s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/content/billing/components/changeplan.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,sBAAsB;EACtB;yBACuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,gDAAgD;EAChD,SAAS;EAET,UAAU;EAEV,gBAAgB;EAIhB,kBAAkB;AAHpB;;AAMA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;;;IAGI;;AAEJ,eAAe;AACf;EACE,uDAAuD;EACvD,aAAa;EACb,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;EAC/C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;6CAC6C;AAC7C;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;GAGG;;AAEH;;;IAGI;;AAEJ,mCAAmC;AACnC;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;EAC1D,uDAAuD;EACvD,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EAEE,oEAAoE;AACtE;;AAEA;;;;EAIE;;AAaF;EACE;IAEE,wBAAwB;EAC1B;;EAEA;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EAEE,qEAAqE;AACvE;;AAEA;;;;EAIE;;AAaF;EACE;IAEE,wBAAwB;EAC1B;;EAEA;IAEE,6BAA6B;EAC/B;AACF;;AAEA,0EAA0E;AAC1E;EAEE,qEAAqE;AACvE;;AAEA;;;;EAIE;;AAqBF;EACE;IACE,+BAA2B;IAA3B,2BAA2B;IAC3B,qCAAqC;IACrC,aAAgB;IAAhB,gBAAgB;IAChB,+BAA+B;IAE/B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,oCAAoC;IACpC,cAAc;IACd,8BAA8B;IAE9B,4BAA4B;EAC9B;AACF;;AAEA;;;;EAIE;AACF,0EAA0E;AAC1E;EAEE,qEAAqE;AACvE;;AAsBA;EACE;IACE,+BAA2B;IAA3B,2BAA2B;IAC3B,qCAAqC;IACrC,aAAgB;IAAhB,gBAAgB;IAChB,+BAA+B;IAE/B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,oCAAoC;IACpC,cAAc;IACd,8BAA8B;IAE9B,6BAA6B;EAC/B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yFAAyF;AACzF;EACE;qDACmD;AACrD;;AAEA;EACE;qDACmD;AACrD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":["/* .button-plan:active {\n   border: 5px solid cornflowerblue;\n} */\n\n* {\n  box-sizing: border-box;\n  /* justify-content: center;\n   align-items: center; */\n}\n\ndiv.column:nth-child(1) > ul:nth-child(1) > li:nth-child(1) {\n  padding-top: 89px;\n}\n\n.table {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 48px;\n}\n\n.column {\n  float: left;\n  column-width: auto;\n}\n\n/* Clear floats after the columns */\n.row:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n/* Style the list */\n.price {\n  list-style-type: none;\n  /* border: 1px solid var(--color-bg-mid-grey); */\n  margin: 0;\n  margin-right: 0px;\n  padding: 0;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n\n.price {\n  margin-right: 61px;\n}\n\n.price li {\n  padding: 16px;\n}\n\n/* Add shadows on hover */\n.price:hover {\n  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);\n}\n\n/* Pricing header */\n/* .price .header {\n   color: rgb(0, 0, 0);\n   font-size: 20px;\n } */\n\n/* List items */\n.price li {\n  /* border-bottom: 1px solid var(--color-bg-mid-grey); */\n  padding: 20px;\n  text-align: left;\n}\n\n/* Grey list item */\n.price .grey {\n  background-color: var(--color-bg-mid-grey);\n  font-size: 20px;\n}\n\n/* The \"Sign Up\" button */\n.button {\n  background-color: var(--color-success-material);\n  border: none;\n  color: white;\n  padding: 10px 25px;\n  text-align: center;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n.featureList {\n  text-align: left;\n}\n\n.amount {\n  font-family: 'Inter';\n  font-size: 48px;\n  font-weight: 999;\n  line-height: 43px;\n  letter-spacing: -0.02em;\n  text-align: center;\n  color: var(--color-primary);\n}\n\n.amountDuration {\n  font-family: Raleway;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 38px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: rgba(29, 41, 57, 1);\n}\n\n/* Change the width of the three columns to 100%\n   (to stack horizontally on small screens) */\n@media only screen and (max-width: 600px) {\n  .columns {\n    width: 100%;\n  }\n}\n\n/* p {\n  font-family: Arial;\n  font-size: 9px;\n} */\n\n/* .column {\n   float: left;\n   width: 33.33%;\n } */\n\n/* Clear floats after the columns */\n.row:after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\n.dollar:before {\n  content: '$';\n  vertical-align: top;\n  font-family: Raleway;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: var(--color-primary);\n  margin-right: 8px;\n}\n\n.dollarWhite:before {\n  content: '$';\n  vertical-align: top;\n  font-family: Raleway;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 24px;\n  letter-spacing: 0em;\n  text-align: center;\n  color: white;\n  margin-right: 8px;\n}\n\n.timeline {\n  font-family: 'Inter';\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  text-align: center;\n  color: var(--color-primary);\n}\n\n.change-plan-wrapper .btn {\n  background: var(--color-accent-violet);\n  color: var(--color-white) !important;\n  font-weight: 100;\n  padding: 20px;\n  /* text-transform: uppercase; */\n  border-radius: 6px;\n  display: inline-block;\n  transition: all 0.3s ease 0s;\n}\n\n.change-plan-wrapper .btn:hover {\n  color: var(--color-text-charcoal) !important;\n  font-weight: 700 !important;\n  letter-spacing: 3px;\n  background: none;\n  -webkit-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);\n  -moz-box-shadow: 0px 5px 40px -10px rgba(0, 0, 0, 0.57);\n  transition: all 0.3s ease 0s;\n}\n\n/* Animation code */\n.slide-left {\n  -webkit-animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n  animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n}\n\n/**\n * ----------------------------------------\n * animation slide-left\n * ----------------------------------------\n */\n@-webkit-keyframes slide-left {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    -webkit-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n}\n\n@keyframes slide-left {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    -webkit-transform: translateX(116px);\n    transform: translateX(116px);\n  }\n}\n\n.slide-right {\n  -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n}\n\n/**\n * ----------------------------------------\n * animation slide-right\n * ----------------------------------------\n */\n@-webkit-keyframes slide-right {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    -webkit-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n}\n\n@keyframes slide-right {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    -webkit-transform: translateX(-120px);\n    transform: translateX(-120px);\n  }\n}\n\n/* Add this class to smoothly transition background color and text color */\n.slide-right-new {\n  -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n}\n\n/**\n * ----------------------------------------\n * animation slide-right\n * ----------------------------------------\n */\n@-webkit-keyframes slide-right-new {\n  0% {\n    background-color: 'initial';\n    /* Set the initial background color */\n    color: 'initial';\n    /* Set the initial text color */\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    background-color: 'blue';\n    /* Set the target background color */\n    color: 'white';\n    /* Set the target text color */\n    -webkit-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n}\n\n@keyframes slide-right-new {\n  0% {\n    background-color: 'initial';\n    /* Set the initial background color */\n    color: 'initial';\n    /* Set the initial text color */\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    background-color: 'blue';\n    /* Set the target background color */\n    color: 'white';\n    /* Set the target text color */\n    -webkit-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n}\n\n/**\n * ----------------------------------------\n * animation slide-right\n * ----------------------------------------\n */\n/* Add this class to smoothly transition background color and text color */\n.slide-left-new {\n  -webkit-animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n  animation: slide-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n}\n\n@-webkit-keyframes slide-left-new {\n  0% {\n    background-color: 'initial';\n    /* Set the initial background color */\n    color: 'initial';\n    /* Set the initial text color */\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    background-color: 'blue';\n    /* Set the target background color */\n    color: 'white';\n    /* Set the target text color */\n    -webkit-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n}\n\n@keyframes slide-left-new {\n  0% {\n    background-color: 'initial';\n    /* Set the initial background color */\n    color: 'initial';\n    /* Set the initial text color */\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  100% {\n    background-color: 'blue';\n    /* Set the target background color */\n    color: 'white';\n    /* Set the target text color */\n    -webkit-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n}\n\n/* Corrected keyframes for .slide-l */\n@keyframes slide-l {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n/* Corrected keyframes for .slide-r */\n@keyframes slide-r {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n/* Apply initial styles and transition to the element with cubic-bezier timing function */\n.slide-l {\n  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.slide-r {\n  transition: background-color 4s cubic-bezier(0.25, 0.46, 0.45, 0.94),\n    transform 4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.custom-tab-list div[role='tablist'] {\n  display: block !important;\n}\n\n.row-wrapper {\n  padding-top: 1.5rem;\n}\n\n.table-row {\n  display: table-row;\n}\n\n.table-row > td {\n  padding-top: 1rem;\n}\n\n@keyframes shakeJerk {\n  0% {\n    transform: translateX(-50%);\n  }\n  12.5% {\n    transform: translateX(calc(-50% - 6px));\n  }\n  25% {\n    transform: translateX(calc(-50% + 6px));\n  }\n  37.5%, 100% {\n    transform: translateX(-50%);\n  }\n}\n\n.shake-jerk-handle {\n  animation: shakeJerk 1.5s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
